





















import { useVModel } from '@vueuse/core';
import {
  computed,
  defineComponent,
  PropType,
  ref,
  onMounted
} from '@vue/composition-api';
import { createNamespacedHelpers, useStore } from 'vuex-composition-helpers';
import { IWorkflowState } from '@/models';
import {
  IWorkflowStoreState,
  IWorkflowGetters,
  IWorkflowActions,
  IWorkflowMutations
} from '@/store/workflow';

import { setErrorFromAxiosError } from '@/utils/helpers';

import { IRootState } from '@/store';
import { ISystemError } from '@/models/error/error.types';

import { VAutocomplete } from 'vuetify/lib/components';

export default defineComponent({
  name: 'WorkflowStateAutoCompletePicker',

  props: {
    value: {
      type: [Array, Number, Object] as PropType<
        IWorkflowState | number | (IWorkflowState | number)[]
      >
    },

    workflowId: { type: Number, required: true },

    errorMessages: {
      type: [String, Array] as PropType<string | string[]>
    }
  },

  setup(props) {
    const stateVModel = useVModel(props);

    const store = useStore<IRootState>();

    const { useActions, useGetters } = createNamespacedHelpers<
      IWorkflowStoreState,
      IWorkflowGetters,
      IWorkflowActions,
      IWorkflowMutations
    >(store, 'workflow');

    const { getWorkflowStates } = useGetters(['getWorkflowStates']);

    const { fetchWorkflowStates } = useActions(['fetchWorkflowStates']);

    const isLoading = ref(false);

    const error = ref<ISystemError | null>(null);

    const errorMessageList = computed(() => {
      let errorList: string[] = [];

      if (error.value) {
        errorList.push(error.value.message);
      }
      if (props.errorMessages) {
        if (Array.isArray(props.errorMessages)) {
          errorList.push(...props.errorMessages);
        } else {
          errorList.push(props.errorMessages);
        }
      }

      return errorList;
    });

    onMounted(() => {
      isLoading.value = true;

      fetchWorkflowStates(props.workflowId)
        .catch(err => {
          error.value = setErrorFromAxiosError(err);
        })
        .finally(() => {
          isLoading.value = false;
        });
    });

    // /** @public */
    const autocompleteRef = ref<
      InstanceType<typeof VAutocomplete> & { reset: () => void }
    >();

    /** @public */
    function reset() {
      if (autocompleteRef.value) autocompleteRef.value.reset();
    }

    return {
      reset,
      autocompleteRef,
      stateVModel,
      getWorkflowStates,
      isLoading,
      errorMessageList
    };
  }
});
